import Vue from 'vue'
import store from 'store'
import { mapState } from 'vuex'
import { unset, parentContainsChild, contains, toggle, formatPrice } from 'utils/general'
import on from 'dom-event'

Vue.component('free-shipping-calculator', {
  store,
  template: `
    <div class="fs-calculator">
      <div class="fs-calculator__container">
        <div class="fs-calculator__inner">
          <div class="fs-calculator__title__wrapper">
            <div class="fs-calculator__title__text" v-html="title"></div>
            <div v-if="toolTipText" class="fs-calculator__tooltip js-tooltip" ref="tooltip">
              <div
                class="fs-calculator__tooltip__icon js-tooltip-icon"
                @click="showTooltip"
                ref="tooltipIcon"
                role="button">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
              </div>
              <div class="fs-calculator__tooltip__text js-tooltip-content" ref="tooltipContent" :style="{ top: '-' + contentHeight }">
                {{ toolTipText }}
              </div>
            </div>
          </div>
          <div class="fs-calculator__progress__wrapper">
            <span class="fs-calculator__progress__point">{{ formatPrice(0) }}</span>
            <div class="fs-calculator__progress__bar">
              <div class="fs-calculator__progress__bar__inner" :style="{ width: percentage + '%' }"></div>
            </div>
            <span class="fs-calculator__progress__point">{{ thresholdAmountFormatted }}</span>
          </div>
        </div>
      </div>
    </div>
  `,
  props: [
    'thresholdAmount',
    'thresholdAmountFormatted',
    'inProgressText',
    'reachedThresholdText',
    'toolTipText'
  ],
  data () {
    return {
      contentHeight: '0px'
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$refs.tooltipContent) {
        const height = this.$refs.tooltipContent.getBoundingClientRect().height + 20
        this.contentHeight = height + 'px'
      }
    })

    on(document, 'click', e => {
      if (!this.$refs.tooltip) return
      const target = e.target
      const withinContent = parentContainsChild(this.$refs.tooltipContent, target) || target.isEqualNode(this.$refs.tooltipContent)
      const isTooltipIcon = parentContainsChild(this.$refs.tooltipIcon, target) || target.isEqualNode(this.$refs.tooltip)

      if (!contains(this.$refs.tooltip, 'show') || isTooltipIcon) return

      if (!withinContent) unset(this.$refs.tooltip, 'show')
    })
  },
  methods: {
    formatPrice,
    showTooltip () {
      toggle(this.$refs.tooltip, 'show')
    }
  },
  computed: {
    ...mapState('global', [
      'cart'
    ]),
    percentage () {
      const threshold = Number(this.thresholdAmount)
      const cartTotal = Number(this.cart.total_price) / 100

      if (cartTotal > threshold) return 100

      return (100 * cartTotal) / threshold
    },
    title () {
      const threshold = Number(this.thresholdAmount)
      const cartTotal = Number(this.cart.total_price) / 100
      let amount = threshold - cartTotal
      amount = Math.round((amount + Number.EPSILON) * 100) / 100

      if (cartTotal < threshold) return this.inProgressText.replace('<<amount>>', formatPrice(amount * 100))

      return this.reachedThresholdText
    },
  }
})
